module.exports = __webpack_public_path__ + "static/caafoundation-5dcea9bb6bffca9cc0e40c8b99d67b57.png";